import { c2x2Exp, c2x2FromReal, toTuples } from "@csk/core/linear";

export interface DifferentialStructureState {
  readonly ratio: number;
  readonly bridgeAmpAuthToData: number;
  readonly bridgeAmpDataToAuth: number;
  readonly expAuthScale: number;
  readonly expDataScale: number;
  readonly expAuthPhase: {
    readonly re: number;
    readonly im: number;
  };
  readonly maurerCartanAuth: number;
  readonly maurerCartanData: number;
}

export function evaluateDifferentialStructure(
  authMagnitude: number,
  dataMagnitude: number,
  time: number,
): DifferentialStructureState {
  const ratio = authMagnitude / dataMagnitude;
  const scaleFlow = toTuples(
    c2x2Exp(
      c2x2FromReal([
        [time, 0],
        [0, time],
      ]),
    ),
  );
  const phaseFlow = toTuples(
    c2x2Exp(
      c2x2FromReal([
        [0, -time],
        [time, 0],
      ]),
    ),
  );

  return {
    ratio,
    bridgeAmpAuthToData: ratio,
    bridgeAmpDataToAuth: 1 / ratio,
    expAuthScale: scaleFlow[0]?.[0]?.[0] ?? Number.NaN,
    expDataScale: scaleFlow[1]?.[1]?.[0] ?? Number.NaN,
    expAuthPhase: {
      re: phaseFlow[0]?.[0]?.[0] ?? Number.NaN,
      im: phaseFlow[1]?.[0]?.[0] ?? Number.NaN,
    },
    maurerCartanAuth: 1 / authMagnitude,
    maurerCartanData: 1 / dataMagnitude,
  };
}
